import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-fullscreen-app",
  templateUrl: "./fullscreen-app.component.html",
  styleUrls: ["./fullscreen-app.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FullscreenAppComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
